export const translations = {
  en: {
    // nav
    dashboard: "Dashboard", players: "Players", teams: "Teams", training: "Training",
    matches: "Matches", tournaments: "Tournaments", finance: "Finance", inventory: "Inventory",
    documents: "Documents", ai_assistant: "AI Assistant", parents: "Parents", coaches: "Coaches",
    ai_command: "AI Command", my_teams: "My Teams", my_players: "My Children",
    reports: "Reports", notifications: "Notifications", users: "Users", settings: "Settings",
    trash: "Trash", import_players: "Import Players",
    // common
    add: "Add", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel",
    search: "Search", filter: "Filter", export: "Export", import: "Import", actions: "Actions",
    restore: "Restore", archive: "Archive", confirm: "Confirm", close: "Close", view: "View",
    logout: "Logout", loading: "Loading...", no_data: "No data yet", all: "All",
    name: "Name", category: "Category", team: "Team", status: "Status", age: "Age",
    position: "Position", phone: "Phone", amount: "Amount", date: "Date", month: "Month",
    type: "Type", quantity: "Quantity", total: "Total", active: "Active", inactive: "Inactive",
    // dashboard
    total_players: "Total Players", active_players: "Active Players", unpaid_fees: "Unpaid Fees",
    monthly_revenue: "Monthly Revenue", total_expenses: "Total Expenses", net_balance: "Net Balance",
    equipment_stock: "Equipment Stock", upcoming_trainings: "Upcoming Trainings",
    upcoming_matches: "Upcoming Matches", upcoming_tournaments: "Upcoming Tournaments",
    missing_documents: "Missing Documents", insurance: "No Insurance", j6_status: "Missing J6",
    players_by_category: "Players by Category", players_by_team: "Players by Team",
    welcome: "Welcome back", overview: "Here is your academy overview",
    paid: "Paid", unpaid: "Unpaid", partial: "Partial", overdue: "Overdue",
  },
  ar: {
    dashboard: "لوحة القيادة", players: "اللاعبون", teams: "الفرق", training: "التدريبات",
    matches: "المباريات", tournaments: "البطولات", finance: "المالية", inventory: "المخزون",
    documents: "الوثائق", ai_assistant: "المساعد الذكي", parents: "الآباء", coaches: "المدربون",
    ai_command: "مركز الأوامر", my_teams: "فرقي", my_players: "أبنائي",
    reports: "التقارير", notifications: "الإشعارات", users: "المستخدمون", settings: "الإعدادات",
    trash: "المحذوفات", import_players: "استيراد اللاعبين",
    add: "إضافة", edit: "تعديل", delete: "حذف", save: "حفظ", cancel: "إلغاء",
    search: "بحث", filter: "تصفية", export: "تصدير", import: "استيراد", actions: "إجراءات",
    restore: "استعادة", archive: "أرشفة", confirm: "تأكيد", close: "إغلاق", view: "عرض",
    logout: "تسجيل الخروج", loading: "جار التحميل...", no_data: "لا توجد بيانات", all: "الكل",
    name: "الاسم", category: "الفئة", team: "الفريق", status: "الحالة", age: "العمر",
    position: "المركز", phone: "الهاتف", amount: "المبلغ", date: "التاريخ", month: "الشهر",
    type: "النوع", quantity: "الكمية", total: "المجموع", active: "نشط", inactive: "غير نشط",
    total_players: "إجمالي اللاعبين", active_players: "اللاعبون النشطون", unpaid_fees: "رسوم غير مدفوعة",
    monthly_revenue: "الإيرادات الشهرية", total_expenses: "إجمالي المصاريف", net_balance: "الرصيد الصافي",
    equipment_stock: "مخزون المعدات", upcoming_trainings: "التدريبات القادمة",
    upcoming_matches: "المباريات القادمة", upcoming_tournaments: "البطولات القادمة",
    missing_documents: "وثائق ناقصة", insurance: "بدون تأمين", j6_status: "بدون J6",
    players_by_category: "اللاعبون حسب الفئة", players_by_team: "اللاعبون حسب الفريق",
    welcome: "مرحبا بعودتك", overview: "إليك نظرة عامة على أكاديميتك",
    paid: "مدفوع", unpaid: "غير مدفوع", partial: "جزئي", overdue: "متأخر",
  },
};
